export const toastification = {
  data() {
    return {};
  },

  methods: {
    makeToastSuccess(statement, dealy) {
      this.$bvToast.toast("Succuss!", {
        title: `${statement}`,
        variant: "success",
        solid: true,
        autoHideDelay: `${dealy}`,
      });
    },
    makeToastFail(statement) {
      let error = statement.message ? statement.message : statement;
      if (this.$route.meta.auth && error.includes("UNAUTHENTICATED")) {
        localStorage.clear();
        this.$router.push("/login");
      } else {
        this.$bvToast.toast("Please try again...", {
          title: `${error}`,
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      }
    },
  },
};
